import React, { useState, useLayoutEffect } from 'react'
import api from '../api'

import { Button, Input, Space, Table, Alert, Typography, message, Tag, Modal } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'

// import Alipay from 'https://i.n2yun.com.cn/cdn/n2_web/20240904/static/media/alipay.fb7960d688e287342a6f.png'
// import Wxpay from '../../images/wxpay.png'

const { Title, Text, Paragraph } = Typography



//  控制台-云配置
function YunCg(props) {
    const [data, setData] = useState({ Server_name: '测试服', Steam: false, Wx: false, Offline: false })
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [update, setUpdate] = useState(Date.now())

    useLayoutEffect(() => {
        api.post('/api/v2/yuncg', {
            type: 'get',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setData(res.data.data.data.Data)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [update])

    function onClick(name) {
        if (name === 'setServer_name') {
            if (!data.Server_name) {
                message.error('服务器名称不可空, 请输入内容!')
                return
            }

            api.post('/api/v2/yuncg', {
                type: 'setServer_name',
                Server_name: data.Server_name,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        setIsModalOpen(false)
                        message.success('已变更成功!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }

        if (name === 'setWx') {
            api.post('/api/v2/yuncg', {
                type: 'setWx',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        message.success('已变更成功!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
        if (name === 'setSteam') {
            api.post('/api/v2/yuncg', {
                type: 'setSteam',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        message.success('已变更成功!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
        if (name === 'setOffline') {
            api.post('/api/v2/yuncg', {
                type: 'setOffline',
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        setUpdate(Date.now())
                        message.success('已变更成功!')
                    } else {
                        message.error(res.data.data.text)
                    }
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器')
                })
        }
    }

    return (
        <div>
            <Alert
                message="欢迎使用云配置"
                description="在这里可以设置您的基于NZ系列插件相关配置, NZ系列插件会从本站实时获取并自动更新已设置好的云配置, 让配置更方便!"
                showIcon
                style={{ marginBottom: 20 }}
            />

            <props.clear />


            <ProCard title={<Text>NZ Cfx Ban 插件云配置</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: '100%', float: 'left', marginTop: 20 }} bordered headerBordered>
                {/* <div>
                    Cfx 短链接: {data.ip} (建议配置, 方便于系统自动获取服务器名称)
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { onClick('') }}>配置</Button>
                </div> */}
                <div>
                    服务器名称: {data && data.Server_name ? data.Server_name : '无'} (建议配置, 在绑定页面中可以展示服务器名称)
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { setIsModalOpen(true) }}>配置</Button>
                </div>

                <div style={{ marginTop: 10 }}>
                    Steam验证模式: {data.Steam ? '已开启' : '未开启'}
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { onClick('setSteam') }}>变更</Button>
                </div>

                <div style={{ marginTop: 10 }}>
                    微信绑定模式: {data.Wx ? '已开启' : '未开启'}
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { onClick('setWx') }}>变更</Button>
                </div>

                <div style={{ marginTop: 10 }}>
                    离线验证模式: {data.Offline ? '已开启' : '未开启'}  (开启情况下当无法与服务器通信时, 会放行未进行微信绑定的玩家用户进服务器, 如没启用微信绑定模式不受本选项影响)
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { onClick('setOffline') }}>变更</Button>
                </div>


                <div style={{ marginTop: 10 }}>
                    管理员游戏ID列表:
                    <Button type="primary" size='small' style={{ marginLeft: 10 }} onClick={() => { onClick('setOffline') }}>配置</Button>
                </div>

                <div style={{ marginTop: 20 }}>
                    <Text type="secondary">最近修改时间: {data.etime}</Text>
                </div>
            </ProCard>


            <Modal title="编辑服务器名称" open={isModalOpen} onOk={() => { onClick('setServer_name') }} onCancel={() => { setIsModalOpen(false) }} centered>
                <Input style={{ marginTop: 10 }} name='Server_name' onChange={(e) => { setData({ ...data, Server_name: e.target.value }) }} value={data.Server_name} />
            </Modal>
        </div>
    )
}

export default YunCg;